import { Store } from '@tanstack/react-store'
import type { FC } from 'react'

export const modalStore = new Store<
  {
    // oxlint-disable-next-line typescript/no-explicit-any -- to make the store typings work :'(
    Component: FC<any>
    // oxlint-disable-next-line typescript/no-explicit-any -- to make the store typings work :'(
    props: any
    uid: string
  }[]
>([])
